import { KVCameraView } from './KVCameraView'
import { KVOrientationAxes } from './KVOrientationAxes'
import {
  type KVPointCloudVisualizationSettings,
  normalizePointCloudVisualizationSettings,
} from './KVPointCloudVisualizationSettings'

export const KV_VIEW_MODES = [
  'Default',
  'MatCap',
  'Wireframe',
  'Nanite',
] as const

export type KVViewMode = (typeof KV_VIEW_MODES)[number]

const isKVViewMode = (value: unknown): value is KVViewMode =>
  KV_VIEW_MODES.some((mode) => mode === value)

export class KVSceneSettings {
  startingView: KVCameraView | null
  orientationAxes: KVOrientationAxes | null
  occludeWorldSpaceItems: boolean
  pointCloudVisualization: KVPointCloudVisualizationSettings | null
  startingViewMode: KVViewMode

  constructor() {
    this.startingView = null
    this.orientationAxes = null
    this.occludeWorldSpaceItems = false
    this.pointCloudVisualization = null
    this.startingViewMode = 'Default'
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVSceneSettings {
    const kvSettings = new KVSceneSettings()
    if (json.startingView)
      kvSettings.startingView = KVCameraView.fromJSON(json.startingView)
    if (json.orientationAxes)
      kvSettings.orientationAxes = KVOrientationAxes.fromJSON(
        json.orientationAxes
      )
    if (typeof json.occludeWorldSpaceItems === 'boolean') {
      kvSettings.occludeWorldSpaceItems = json.occludeWorldSpaceItems
    }
    if (json.pointCloudVisualization) {
      kvSettings.pointCloudVisualization =
        normalizePointCloudVisualizationSettings(json.pointCloudVisualization)
    }
    if (isKVViewMode(json.startingViewMode)) {
      kvSettings.startingViewMode = json.startingViewMode
    }
    return kvSettings
  }

  static toJSON(kvSettings: KVSceneSettings): any {
    const json: any = {}
    if (kvSettings.startingView) {
      json.startingView = KVCameraView.toJSON(kvSettings.startingView)
    }
    if (kvSettings.orientationAxes) {
      json.orientationAxes = KVOrientationAxes.toJSON(
        kvSettings.orientationAxes
      )
    }
    json.occludeWorldSpaceItems = kvSettings.occludeWorldSpaceItems
    if (kvSettings.pointCloudVisualization) {
      json.pointCloudVisualization = { ...kvSettings.pointCloudVisualization }
    }
    json.startingViewMode = kvSettings.startingViewMode
    return json
  }
}
